// TODO: this should be determined 
// in some way other than system OS
const getGraphQLEndpoint = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/graphql';
  } else {
    return '/graphql';
  }
}

const graphqlEndpoint = getGraphQLEndpoint();


export const graphqlRequest = async (query, variables = {}) => {
  try {
    const response = await fetch(graphqlEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const result = await response.json();

    if (result.errors) {
      throw new Error(result.errors.map((err) => err.message).join(', '));
    }

    return result.data;
  } catch (error) {
    console.error('GraphQL request failed:', error.message);
    throw error;
  }
};
